import * as breakpoints from "~styles/breakpoints.module.scss";

const mediaQuery = (key, bound = `min`) => {
  if (!breakpoints?.[key]) {
    return `@media `;
  }

  return `@media only screen and (${bound}-width: ${breakpoints[key]}) `;
};

export default mediaQuery;
